import { Button, Flex, Icon, Table, Tbody, Text, Th, Thead, Tr } from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaUndo } from "react-icons/fa";
import { ContractTaskDto } from "../../../autogen/bff-api";
import { HorizontalScrollBox } from "../../../common/HorizontalScrollBox";
import { ShowTaskModal } from "../view-single/tasks/show/ShowTaskModal";
import { TaskRow } from "./TaskRow";
import { fixedWidth, TASK_COLUMN_WIDTHS } from "./taskColumnWidths";

interface Props {
  tasks: ContractTaskDto[];
  hasActiveFilters?: boolean;
  onResetFilters?: () => void;
  hasMorePages?: boolean;
}

export const TasksTable = ({ tasks, hasActiveFilters = false, onResetFilters, hasMorePages = false }: Props) => {
  const { t } = useTranslation();
  const [showTaskId, setShowTaskId] = useState<string>();

  return (
    <>
      <HorizontalScrollBox borderRadius={"lg"} border="1px solid" borderColor="smBorder" width="full" maxWidth="full">
        {showTaskId && <ShowTaskModal taskId={showTaskId} onClose={() => setShowTaskId(undefined)} />}
        <Table
          variant="simple"
          size="sm"
          whiteSpace="nowrap"
          sx={{ "td, td p": { overflow: "hidden", textOverflow: "ellipsis" } }}
        >
          <Thead>
            <Tr>
              <Th {...fixedWidth(TASK_COLUMN_WIDTHS.title)}>{t("Title")}</Th>
              <Th {...fixedWidth(TASK_COLUMN_WIDTHS.dueDate)}>{t("Due date")}</Th>
              <Th {...fixedWidth(TASK_COLUMN_WIDTHS.responsible)}>{t("Responsible")}</Th>
              <Th {...fixedWidth(TASK_COLUMN_WIDTHS.contract)}>{t("Contract")}</Th>
              <Th {...fixedWidth(TASK_COLUMN_WIDTHS.owner)}>{t("Contract owner")}</Th>
              <Th {...fixedWidth(TASK_COLUMN_WIDTHS.status)}>{t("Status")}</Th>
            </Tr>
          </Thead>
          <Tbody>
            {tasks.map((e) => {
              return <TaskRow key={e.id} task={e} showTask={(e) => setShowTaskId(e)} />;
            })}
          </Tbody>
        </Table>
      </HorizontalScrollBox>
      {tasks.length === 0 && hasMorePages && (
        <Flex justify="center" py="16" textAlign="center">
          <Text color="smMuted">{t("No tasks you have access to on this page. The next page may have more.")}</Text>
        </Flex>
      )}
      {tasks.length === 0 && !hasMorePages && (
        <Flex direction="column" align="center" gap="3" py="16" textAlign="center">
          <Text color="smMuted">{hasActiveFilters ? t("No tasks match your filters.") : t("No tasks yet.")}</Text>
          {hasActiveFilters && onResetFilters && (
            <Button
              leftIcon={<Icon as={FaUndo} />}
              variant="outline"
              colorScheme="gray"
              color="smMuted"
              size="sm"
              onClick={onResetFilters}
            >
              {t("Reset table")}
            </Button>
          )}
        </Flex>
      )}
    </>
  );
};
